import { NumberSchema } from '../common/processed';
import * as z from 'zod';

export const OptionalNumberArraySchema = z.array(NumberSchema).optional();
